import React from "react";
import InfoBlock from "../grundelemente/InfoBlock";
import InfoDateContainer from "../grundelemente/InfoDateContainer";
import InfoPanel from "../grundelemente/InfoPanel";

import "./ZubehoerInfo.css";

const ZubehoerInfoPanel = () => (
	<InfoPanel>
		<InfoBlock className="Zubehoer-Info-Dummy">
		</InfoBlock>
		<InfoDateContainer />
	</InfoPanel>
);

export default ZubehoerInfoPanel;
